import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Col, Row, Button, Form, Badge, Modal, ModalHeader, ModalFooter, ModalBody,
    FormGroup, Input, InputGroup,
    InputGroupAddon,
    InputGroupText,
    FormFeedback,
    Label
} from 'reactstrap';
import { reputeinfoBalancePackageActions } from "../../actions";
class UpdateBalanceSetting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formData: {
                id : '',
                type : '',
                value : '',
            },
            errors: {},
            thisModel: false,
        }
        this.handleToggle = this.handleToggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handelSubmit = this.handelSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    handleToggle() {
        const { thisModel, formData } = this.state;
        const { editData, getBalanceSetting } = this.props

        this.setState({
            thisModel: !thisModel,
        });
        console.log('thisModel', thisModel)
        if (thisModel == true) {
            this.reset()

        }
    }
    handleChange(event) {
        const { name, value, type } = event.target;
        let { formData, errors } = this.state;
        let val = value;
        formData[name] = val
        errors[name] = ''

        // set value to state
        this.setState({ formData, errors },
            () => { }
        );
    }
    isValid() {
        const { formData, errors } = this.state
        let error = false;
        if (!formData.value) {
            error = true
            errors.value = "this field is requited"
        }

        this.setState({ errors })
        return error;
    }

    handelSubmit() {
        if (!this.isValid()) {
            const { formData } = this.state
            const { dispatch, editData } = this.props
            
            let dataToSend = {
                id: formData.id,
                value: formData.value,
            }
            dispatch(reputeinfoBalancePackageActions.updateBalanceSetting(dataToSend, {
                success: () => this.handleToggle()
            }))
        }
    }
    reset() {
        let { formData } = this.state
        const { editData, getBalanceSetting } = this.props
        formData.id = ''
        formData.value = ''
        formData.type = ''
        this.setState({ formData, erroes: {} })
        if (typeof getBalanceSetting == 'function') {
            getBalanceSetting()
        }
    }

    setEditData(editData) {
        let { formData } = this.state
        if (editData) {
            formData.id = editData.id
            formData.type = editData.type
            formData.value = editData.value
                this.setState({ formData })
        }

    }
    componentDidMount() {
        const { editData } = this.props
        if (editData) {
            this.setEditData(editData)
        }
    }

    render() {
        const { title, editData } = this.props
        const { formData, thisModel, errors } = this.state
        const mendetoryFields = {
            color: "red",
            fontSize: "14px",
            marginLeft: "2px",
        };
        return (
            <React.Fragment>
                <Button size='sm'  color="primary" onClick={this.handleToggle}>{"Edit"}</Button>&nbsp;
                <Modal className="modal-primary" isOpen={thisModel} backdrop="static" size="md" toggle={this.handleToggle} >
                    <ModalHeader toggle={this.handleToggle}> {editData ? "Edit" : "Add"} Bad Debt  </ModalHeader>
                    <ModalBody >
                        <Row sm="12">
                            <Col>
                                <Input type="text" value={formData.type} name="type" disabled={"disabled"}  /><br/>
                            </Col>
                        </Row >
                        <Row sm="12">
                            <Col>
                                <Input type="text" value={formData.value} name="value" onChange={this.handleChange}  />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handelSubmit}>Submit </Button>

                        <Button color="secondary" onClick={this.handleToggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {}
}

const connectedUpdateBalanceSetting = connect(mapStateToProps)(UpdateBalanceSetting);
export { connectedUpdateBalanceSetting as UpdateBalanceSetting }